import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  deleteWebhookEndpoint,
  DeleteWebhookEndpointPayload,
} from 'api/admin/businesses/editWebhookEndpoint';

export const useDeleteWebhookEndpoint = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, DeleteWebhookEndpointPayload>({
    mutationFn: async ({ configId, businessId }) => {
      return deleteWebhookEndpoint({
        configId,
        businessId,
      });
    },
    onSuccess: async () => {
      toaster('Webhook endpoint has been deleted', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while deleting webhook endpoint', {
        icon: '❌',
      });
      return error;
    },
  });
};
